import LinkTag from '@/components/common/LinkTag';
import PaginationComponent from '@/components/common/PaginationComponent';
import MedicineDictionary from '@/entities/medicine-dictionary/ui/MedicineDictionary';
import { ROUTES } from '@/types/common';
import useSearchTotalMedicineDictionaryViewModel from '../hook/useSearchTotalMedicineDictionaryViewModel';

const SearchTotalMedicineDictionary = () => {
  const viewModel = useSearchTotalMedicineDictionaryViewModel();

  return (
    <div className='flex flex-col gap-[16px] px-[24px] pt-[32px] pb-[80px]'>
      <div className='flex flex-col'>
        <h2 className='typography-ui-20sb mb-4 text-gray-700 '>전체 약품</h2>
        <div className='grid grid-cols-1 gap-[28px] md:grid-cols-2' suppressHydrationWarning>
          {viewModel.medicineDictionaryItems.map((item) => (
            <LinkTag
              key={item.getPublicId()}
              href={`${ROUTES.MEDICINE_DICTIONARY.DETAIL.path}/${item.getPublicId()}`}
              onClickNavigateToScreen={viewModel.onClickMedicineDictionary(item)}
            >
              <MedicineDictionary
                title={item.getBasicInfoName()}
                description={item.getPharmaceuticalEffectLiteracy()}
                summary={item.getWholeSummary()}
                image={item.getRepresentativeImage()}
                imageAlt={item.getSimplifiedName()}
              />
            </LinkTag>
          ))}
        </div>
      </div>
      <PaginationComponent
        baseUrl={viewModel.paginationBaseUrl}
        queries={viewModel.queries}
        currentPage={viewModel.currentPage}
        perPage={5}
        totalPage={viewModel.totalPage}
        scroll={false}
      />
    </div>
  );
};

export default SearchTotalMedicineDictionary;
